export const stalls = [
  {
    name: "BlockA_101",
    category: "3BHK",
    sft: 2148,
    facing: "North",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.389909866698861,
        z: -4.083464166376028,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.565466158190708,
        z: -4.082843088325318,
        elevation: 0.8500000238418588,
      },
      {
        levelIndex: 0,
        x: 4.5693010333442015,
        z: -4.238368493655736,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.389341886650238,
        z: -4.238779411295269,
        elevation: 0.850000023841857,
      },
    ],
  },
  {
    name: "BlockA_102",
    category: "3BHK",
    sft: 2148,
    facing: "North",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.609910027667251,
        z: -4.082713886030725,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.79222590516073,
        z: -4.080190863794258,
        elevation: 0.850000023841857,
      },
      {
        levelIndex: 0,
        x: 4.791380050360914,
        z: -4.2399384941169735,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.609200300670117,
        z: -4.240245142046708,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockA_103",
    category: "3BHK",
    sft: 2148,
    facing: "North",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.85007693699184,
        z: -4.078969569571151,
        elevation: 0.8448937330212756,
      },
      {
        levelIndex: 0,
        x: 5.007802343490975,
        z: -4.079231966141651,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.004729043652059,
        z: -4.247838513783336,
        elevation: 0.8299999833107021,
      },
      {
        levelIndex: 0,
        x: 4.846796247611767,
        z: -4.242544975999341,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockA_104",
    category: "3BHK",
    sft: 2148,
    facing: "North",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.0655509697565995,
        z: -4.079728427743688,
        elevation: 0.850000023841857,
      },
      {
        levelIndex: 0,
        x: 5.2342591560945015,
        z: -4.083224076074597,
        elevation: 0.8500000238418588,
      },
      {
        levelIndex: 0,
        x: 5.231117882367963,
        z: -4.242870065550475,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.069194589539734,
        z: -4.237473015657356,
        elevation: 0.8500000238418588,
      },
    ],
  },
  {
    name: "BlockA_105",
    category: "3BHK",
    sft: 2065,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.068316724241447,
        z: -3.833400730031728,
        elevation: 0.850000023841857,
      },
      {
        levelIndex: 0,
        x: 5.234958815864503,
        z: -3.8345757837871424,
        elevation: 0.8500000238418588,
      },
      {
        levelIndex: 0,
        x: 5.2359354484082425,
        z: -4.001164551295949,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.064784909135394,
        z: -4.001995092754527,
        elevation: 0.8500000238418597,
      },
    ],
  },
  {
    name: "BlockA_106",
    category: "3BHK",
    sft: 2065,
    facing: "West",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.06473486921745,
        z: -3.7698990773112504,
        elevation: 0.8423963785171518,
      },
      {
        levelIndex: 0,
        x: 5.066943484477132,
        z: -3.600719609175193,
        elevation: 0.8500000238418588,
      },
      {
        levelIndex: 0,
        x: 5.233632550275837,
        z: -3.600763940192764,
        elevation: 0.850000023841857,
      },
      {
        levelIndex: 0,
        x: 5.231302440980107,
        z: -3.767249448438048,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockA_107",
    category: "3BHK",
    sft: 2089,
    facing: "East",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.843261458226903,
        z: -3.5965206355543997,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.005322339244365,
        z: -3.601039555760217,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.0069067295688505,
        z: -3.767708433141202,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.844683562597679,
        z: -3.7677683373691773,
        elevation: 0.8423963785171544,
      },
    ],
  },
  {
    name: "BlockA_108",
    category: "3BHK",
    sft: 2138,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.01120882231563,
        z: -3.8320512499024457,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 5.011721752023188,
        z: -4.008376696478649,
        elevation: 0.8423963785171511,
      },
      {
        levelIndex: 0,
        x: 4.844797584744821,
        z: -4.009341649127768,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 4.846229310522228,
        z: -3.8313250728607255,
        elevation: 0.8500000238418581,
      },
    ],
  },
  {
    name: "BlockA_109",
    category: "3BHK",
    sft: 2065,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.603677912682088,
        z: -3.832075424804217,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 4.790585402271408,
        z: -3.831442345870208,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.791436191330691,
        z: -4.002458722588007,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 4.6044612469469675,
        z: -4.005452008651156,
        elevation: 0.8423963785171509,
      },
    ],
  },
  {
    name: "BlockA_110",
    category: "3BHK",
    sft: 2065,
    facing: "West",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.607917009964211,
        z: -3.598827173158781,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 4.79466108967139,
        z: -3.6028235242939495,
        elevation: 0.8500000238418588,
      },
      {
        levelIndex: 0,
        x: 4.793814351040789,
        z: -3.762741184942151,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.602248301776196,
        z: -3.767544294500172,
        elevation: 0.84239637851715,
      },
    ],
  },
  {
    name: "BlockA_111",
    category: "3BHK",
    sft: 2089,
    facing: "East",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.401159304401668,
        z: -3.555428013891059,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.570164168834097,
        z: -3.5544883294404697,
        elevation: 0.850000023841857,
      },
      {
        levelIndex: 0,
        x: 4.5721062248571664,
        z: -3.7461186565774343,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 4.403683180601433,
        z: -3.739949004875108,
        elevation: 0.8500000238418588,
      },
    ],
  },
  {
    name: "BlockA_112",
    category: "3BHK",
    sft: 2084,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.399998960056237,
        z: -3.8113816512946928,
        elevation: 0.84239637851715,
      },
      {
        levelIndex: 0,
        x: 4.567120036671642,
        z: -3.8098271152686083,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.565485410936553,
        z: -3.987391084429725,
        elevation: 0.850000023841873,
      },
      {
        levelIndex: 0,
        x: 4.398602490465579,
        z: -3.984659997200213,
        elevation: 0.8423963785171527,
      },
    ],
  },
  {
    name: "BlockB_101",
    category: "3BHK",
    sft: 2130,
    facing: "North",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.333462272739174,
        z: -4.082851520574928,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.4787436313887925,
        z: -4.081799882635398,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.478436939363381,
        z: -4.242874517541105,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.335803291349782,
        z: -4.243717680789494,
        elevation: 0.8500000238418561,
      },
    ],
  },
  {
    name: "BlockB_102",
    category: "3BHK",
    sft: 2130,
    facing: "North",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.552661934278572,
        z: -4.081824942312407,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 5.721818088676442,
        z: -4.080851792779651,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.724100449312883,
        z: -4.241713877946246,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.551923525046897,
        z: -4.237764204553816,
        elevation: 0.8423963785171527,
      },
    ],
  },
  {
    name: "BlockB_103",
    category: "3BHK",
    sft: 2130,
    facing: "North",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.787604295163314,
        z: -4.076255267943322,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.972971346612548,
        z: -4.081897606761741,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.967338759553056,
        z: -4.243386050613333,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.787669938531951,
        z: -4.24269264047226,
        elevation: 0.8423963785171509,
      },
    ],
  },
  {
    name: "BlockB_104",
    category: "2BHK",
    sft: 1143,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 6.006539211991802,
        z: -3.7463186502167125,
        elevation: 0.8500000238418561,
      },
      {
        levelIndex: 0,
        x: 6.13834522386715,
        z: -3.741399067564775,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 6.1294494663676105,
        z: -3.8703619316929734,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 6.004702038500271,
        z: -3.8749774479573666,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockB_105",
    category: "3BHK",
    sft: 2385,
    facing: "West",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 6.001322749192703,
        z: -3.462851350065653,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 6.1670348764233545,
        z: -3.4644768150293954,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 6.166089298864566,
        z: -3.6404558487069476,
        elevation: 0.8500000238418615,
      },
      {
        levelIndex: 0,
        x: 6.007460015736204,
        z: -3.644777144171572,
        elevation: 0.8500000238418561,
      },
    ],
  },
  {
    name: "BlockB_106",
    category: "3BHK",
    sft: 2014,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.791894202767111,
        z: -3.3566971262027065,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.958351139092277,
        z: -3.3650948617250815,
        elevation: 0.8500000238418615,
      },
      {
        levelIndex: 0,
        x: 5.955602880894871,
        z: -3.483760393058322,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.792984647787325,
        z: -3.4816767748538053,
        elevation: 0.8500000238418561,
      },
    ],
  },
  {
    name: "BlockB_107",
    category: "3BHK",
    sft: 2089,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.7861143294999176,
        z: -3.5535598694277133,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.9519406211548285,
        z: -3.555133486409129,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.958648606036151,
        z: -3.740541420969153,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.792705524104473,
        z: -3.738767406961646,
        elevation: 0.8500000238418597,
      },
    ],
  },
  {
    name: "BlockB_108",
    category: "3BHK",
    sft: 2089,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.791132058085501,
        z: -4.018825813674681,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.9470785466437155,
        z: -4.020458894259706,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 5.951873481956529,
        z: -3.827051746541554,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.782485139701099,
        z: -3.8267317352948287,
        elevation: 0.8423963785171509,
      },
    ],
  },
  {
    name: "BlockB_109",
    category: "3BHK",
    sft: 2065,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.518823080326027,
        z: -3.832268417115399,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.6979536519861655,
        z: -3.8282483527902036,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.698499521477201,
        z: -4.0071351788795,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.52350257944383,
        z: -4.017526546320609,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockB_110",
    category: "3BHK",
    sft: 2065,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.520006408120115,
        z: -3.7407371924346418,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 5.696361864679052,
        z: -3.7434449286022335,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.698094427872459,
        z: -3.553745682441066,
        elevation: 0.8500000238418561,
      },
      {
        levelIndex: 0,
        x: 5.518013369426258,
        z: -3.5482288656605627,
        elevation: 0.8299999833106995,
      },
    ],
  },
  {
    name: "BlockB_111",
    category: "3BHK",
    sft: 1843,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.522182752181477,
        z: -3.313689611831668,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.698255170587116,
        z: -3.313358186694991,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.695278440220021,
        z: -3.4558519652934274,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.522578368245837,
        z: -3.455856284833065,
        elevation: 0.8500000238418561,
      },
    ],
  },
  {
    name: "BlockB_112",
    category: "3BHK",
    sft: 2089,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.324622014908885,
        z: -3.55463473660956,
        elevation: 0.7900000214576721,
      },
      {
        levelIndex: 0,
        x: 5.468391568132497,
        z: -3.5593410039182896,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.4690574380729915,
        z: -3.7386575186380684,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.333604556213113,
        z: -3.7384007562753605,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockB_113",
    category: "3BHK",
    sft: 2089,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.332763566046484,
        z: -3.833233828037844,
        elevation: 0.8500000238418561,
      },
      {
        levelIndex: 0,
        x: 5.471889124631145,
        z: -3.8365122849191398,
        elevation: 0.8500000238418561,
      },
      {
        levelIndex: 0,
        x: 5.474920600317586,
        z: -4.005375772131513,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.332788707121776,
        z: -4.005779114069048,
        elevation: 0.8500000238418597,
      },
    ],
  },
  {
    name: "BlockC_101",
    category: "2BHK",
    sft: 1265,
    facing: "North",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 2.841253621894988,
        z: -2.6763011118804783,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 2.948725512392355,
        z: -2.674479077623365,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 2.9490412195787172,
        z: -2.5644510503193145,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 2.817565657304976,
        z: -2.559542520548434,
        elevation: 0.8423963785171509,
      },
    ],
  },
  {
    name: "BlockC_02",
    category: "2BHK",
    sft: 1101,
    facing: "North",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 2.992380587567502,
        z: -2.6755517727530562,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 2.9932364099289033,
        z: -2.5651072325673754,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 3.124902023002939,
        z: -2.5565549821898834,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 3.1214551019176455,
        z: -2.6727948254189404,
        elevation: 0.8500000238418597,
      },
    ],
  },
  {
    name: "BlockC_103",
    category: "2BHK",
    sft: 1101,
    facing: "North",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.160035840569576,
        z: -2.5544024374881893,
        elevation: 0.8423963785171544,
      },
      {
        levelIndex: 0,
        x: 3.32530040500572,
        z: -2.5549691481018852,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 3.3322548956449753,
        z: -2.6711512985874255,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 3.164200877145019,
        z: -2.6796703222710994,
        elevation: 0.8423963785171509,
      },
    ],
  },
  {
    name: "BlockC_104",
    category: "2BHK",
    sft: 1101,
    facing: "North",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.363710046653358,
        z: -2.5545957741942216,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 3.5164726607294674,
        z: -2.5585723334052215,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 3.5143225635314357,
        z: -2.6718587290297995,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 3.3658718278435678,
        z: -2.6718589618021866,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockC_105",
    category: "2BHK",
    sft: 1101,
    facing: "North",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.547039998992219,
        z: -2.6761616261694954,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 3.698703677214186,
        z: -2.6793866171179874,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 3.696181090342858,
        z: -2.5566445928042985,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 3.548497939241198,
        z: -2.5578326020886184,
        elevation: 0.8500000238418597,
      },
    ],
  },
  {
    name: "BlockC_106",
    category: "2BHK",
    sft: 1249,
    facing: "North",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.7762292711023964,
        z: -2.557885160784465,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 3.959767985365674,
        z: -2.556982348759884,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 3.960067735334971,
        z: -2.672037552210141,
        elevation: 0.8500000238418615,
      },
      {
        levelIndex: 0,
        x: 3.7740386006598476,
        z: -2.6740935633113874,
        elevation: 0.8423963785171491,
      },
    ],
  },
  {
    name: "BlockC_107",
    category: "2BHK",
    sft: 1228,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.775174272887505,
        z: -2.3969069885902488,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 3.9582582752294893,
        z: -2.400454364040439,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 3.9594288238993856,
        z: -2.514117803600353,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 3.77448033269975,
        z: -2.5239919901773247,
        elevation: 0.8423963785171544,
      },
    ],
  },
  {
    name: "BlockC_108",
    category: "2BHK",
    sft: 1296,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.775348885369271,
        z: -2.23185165276959,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 3.9629127640584367,
        z: -2.2351959717931487,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 3.963419725186724,
        z: -2.369702202633068,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 3.774989616014309,
        z: -2.363727960599101,
        elevation: 0.8423963785171527,
      },
    ],
  },
  {
    name: "BlockC_109",
    category: "2BHK",
    sft: 1296,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.7763196836377775,
        z: -2.0447987361560744,
        elevation: 0.8299999833106995,
      },
      {
        levelIndex: 0,
        x: 3.9596060144994993,
        z: -2.0606114293698985,
        elevation: 0.8299999833106995,
      },
      {
        levelIndex: 0,
        x: 3.9620820951753792,
        z: -2.1942841502994144,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 3.7799461224299464,
        z: -2.2002354376421414,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockC_110",
    category: "2BHK",
    sft: 1228,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.5670986729643825,
        z: -2.0338406128132793,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 3.7204525257619094,
        z: -2.0417461788014566,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 3.724491655715864,
        z: -2.188876834080323,
        elevation: 0.8423963785171491,
      },
      {
        levelIndex: 0,
        x: 3.5642859119133985,
        z: -2.18570989755092,
        elevation: 0.8423963785171509,
      },
    ],
  },
  {
    name: "BlockC_111",
    category: "2BHK",
    sft: 1214,
    facing: "East",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.564794288197063,
        z: -2.234991024283194,
        elevation: 0.8423963785171544,
      },
      {
        levelIndex: 0,
        x: 3.722797017139025,
        z: -2.230552750475801,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 3.7199257039120015,
        z: -2.3629681078545928,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 3.5669945960179485,
        z: -2.3661419302433147,
        elevation: 0.8423963785171527,
      },
    ],
  },
  {
    name: "BlockC_112",
    category: "2BHK",
    sft: 1214,
    facing: "East",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.5683026753276357,
        z: -2.3985215160783198,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 3.721824621712383,
        z: -2.398232545724254,
        elevation: 0.8445659749768151,
      },
      {
        levelIndex: 0,
        x: 3.7240016275421164,
        z: -2.529402152566991,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 3.5656470636448763,
        z: -2.522986564314961,
        elevation: 0.8423963785171527,
      },
    ],
  },
  {
    name: "BlockC_113",
    category: "2BHK",
    sft: 1237,
    facing: "West",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.387988862380052,
        z: -2.3739063260087083,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 3.526595590493187,
        z: -2.3776466781420353,
        elevation: 0.8500000238418561,
      },
      {
        levelIndex: 0,
        x: 3.5225496890190766,
        z: -2.4775636158997276,
        elevation: 0.8500000238418561,
      },
      {
        levelIndex: 0,
        x: 3.394734683093078,
        z: -2.48155720053444,
        elevation: 0.8500000238418597,
      },
    ],
  },
  {
    name: "BlockC_114",
    category: "2BHK",
    sft: 1237,
    facing: "West",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.3892516539774578,
        z: -2.1978057782872225,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 3.532063506858037,
        z: -2.1977605462998118,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 3.5331404956544894,
        z: -2.315519484594699,
        elevation: 0.8423963785171544,
      },
      {
        levelIndex: 0,
        x: 3.3963934776807077,
        z: -2.316477577186297,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockC_115",
    category: "2BHK",
    sft: 1237,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.3890488774661787,
        z: -2.01657833967459,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 3.531697095661968,
        z: -2.024924695359117,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 3.528044204520025,
        z: -2.135768692680678,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 3.392926208816881,
        z: -2.1336169494867074,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockC_116",
    category: "2BHK",
    sft: 1220,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.1816645291723686,
        z: -2.150355170051614,
        elevation: 0.813253082980065,
      },
      {
        levelIndex: 0,
        x: 3.3651857199174957,
        z: -2.152572735763108,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 3.3638005520535135,
        z: -2.317657790858276,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 3.185567273643746,
        z: -2.3197831535903246,
        elevation: 0.8423963785171527,
      },
    ],
  },
  {
    name: "BlockC_117",
    category: "2BHK",
    sft: 1206,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 3.1860915028158585,
        z: -2.357997754816684,
        elevation: 0.8500000238418632,
      },
      {
        levelIndex: 0,
        x: 3.358855315784863,
        z: -2.357497534450297,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 3.361474696171128,
        z: -2.4993900979498567,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 3.1818022888147253,
        z: -2.4965862226390505,
        elevation: 0.8423963785171527,
      },
    ],
  },
  {
    name: "BlockC_118",
    category: "2BHK",
    sft: 1237,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 2.972384003883387,
        z: -2.463607707138576,
        elevation: 0.8500000238418561,
      },
      {
        levelIndex: 0,
        x: 2.967761733352243,
        z: -2.3359927575279285,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 3.137500964421181,
        z: -2.3418456194528154,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 3.134585374849918,
        z: -2.466296818959685,
        elevation: 0.8423963785171509,
      },
    ],
  },
  {
    name: "BlockC_119",
    category: "2BHK",
    sft: 1237,
    facing: "West",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 2.9709303901518176,
        z: -2.1508618924721694,
        elevation: 0.8299999833106977,
      },
      {
        levelIndex: 0,
        x: 3.1383246052180853,
        z: -2.154984647209449,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 3.136271177035196,
        z: -2.3202877385320746,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 2.9669605998726816,
        z: -2.3142538414236378,
        elevation: 0.8423963785171509,
      },
    ],
  },
  {
    name: "BlockC_120",
    category: "2BHK",
    sft: 1316,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 2.737599109241388,
        z: -2.1553994552694293,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 2.9323268176008495,
        z: -2.1567028977093012,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 2.926580785717478,
        z: -2.314936076585574,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 2.766479080723187,
        z: -2.328150988425851,
        elevation: 0.8299999833106995,
      },
    ],
  },
  {
    name: "BlockC_121",
    category: "3BHK",
    sft: 1803,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 2.786164320404965,
        z: -2.344489428916889,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 2.9224639818150644,
        z: -2.3408341878787002,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 2.941620087903659,
        z: -2.530253417855407,
        elevation: 0.8423963785171491,
      },
      {
        levelIndex: 0,
        x: 2.801070566852984,
        z: -2.5277234489286724,
        elevation: 0.7900000214576739,
      },
    ],
  },
  {
    name: "BlockD_112",
    category: "3BHK",
    sft: 1665,
    facing: "East",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.713785709456176,
        z: -3.2458161307165225,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 4.904706225458435,
        z: -3.244842606587624,
        elevation: 0.8500000238418615,
      },
      {
        levelIndex: 0,
        x: 4.900321946483049,
        z: -3.4361185632251825,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.697364045653444,
        z: -3.4507274711570073,
        elevation: 0.012396352365612984,
      },
    ],
  },
  {
    name: "BlockD_111",
    category: "3BHK",
    sft: 1665,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.698433030240798,
        z: -3.010682022961348,
        elevation: 0.013594528660178185,
      },
      {
        levelIndex: 0,
        x: 4.901188700437943,
        z: -3.02431482952957,
        elevation: 0.8500000238418561,
      },
      {
        levelIndex: 0,
        x: 4.9062497926826785,
        z: -3.19077082857231,
        elevation: 0.8500000238418615,
      },
      {
        levelIndex: 0,
        x: 4.712649997442256,
        z: -3.1926016367485217,
        elevation: 0.8500000238418597,
      },
    ],
  },
  {
    name: "BlockD_110",
    category: "3BHK",
    sft: 1665,
    facing: "East",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.7181553054883345,
        z: -2.785693260276345,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.903590744164974,
        z: -2.7818242810624594,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.907908754793219,
        z: -2.972467291761842,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 4.7193767237452375,
        z: -2.9713741952235706,
        elevation: 0.8500000238418597,
      },
    ],
  },
  {
    name: "BlockD_109",
    category: "2BHK",
    sft: 1367,
    facing: "West",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.935904234168122,
        z: -2.781965906638159,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.068186301370167,
        z: -2.78468957860844,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 5.0662548356129165,
        z: -2.9332196612261052,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.934395596018641,
        z: -2.9326619597309955,
        elevation: 0.8423963785171544,
      },
    ],
  },
  {
    name: "BlockD_108",
    category: "2BHK",
    sft: 1367,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.937857344021075,
        z: -3.0456439334114487,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.067853850162536,
        z: -3.054113324972032,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.066976165719844,
        z: -3.215751208840183,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 4.935151756466643,
        z: -3.2153946904670447,
        elevation: 0.8423963785171544,
      },
    ],
  },
  {
    name: "BlockD_107",
    category: "2BHK",
    sft: 1367,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.9351383738652,
        z: -3.291009708520465,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.064014914908672,
        z: -3.286656820519641,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 5.0677150646175,
        z: -3.440033673489301,
        elevation: 0.8299999833106995,
      },
      {
        levelIndex: 0,
        x: 4.932664382960871,
        z: -3.4365172774222428,
        elevation: 0.8423963785171527,
      },
    ],
  },
  {
    name: "BlockD_106",
    category: "2BHK",
    sft: 1358,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.10212442741488,
        z: -3.2944810936607576,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.255254473891808,
        z: -3.2883583513610684,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.250464016278375,
        z: -3.4394164470689064,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.104035918046794,
        z: -3.4462559533318258,
        elevation: 0.7900000214576721,
      },
    ],
  },
  {
    name: "BlockD_105",
    category: "3BHK",
    sft: 1665,
    facing: "East",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.097652575109713,
        z: -3.0221334756467333,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.256549135893472,
        z: -3.025865719785115,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.262255750224584,
        z: -3.19764694580544,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 5.100221638999791,
        z: -3.1915918161575014,
        elevation: 0.8423963785171509,
      },
    ],
  },
  {
    name: "BlockD_104",
    category: "3BHK",
    sft: 1665,
    facing: "East",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.103240821299387,
        z: -2.787603830184306,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.256985856395342,
        z: -2.791621535233212,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.258115148643651,
        z: -2.977293180368126,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.099212614913939,
        z: -2.973525963818365,
        elevation: 0.8423963785171509,
      },
    ],
  },
  {
    name: "BlockD_103",
    category: "2BHK",
    sft: 1367,
    facing: "West",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.275790922048636,
        z: -2.7871610404279092,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.418541726844281,
        z: -2.792329510211718,
        elevation: 0.8500000238418561,
      },
      {
        levelIndex: 0,
        x: 5.42698575329469,
        z: -2.9343507964468474,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.2766504322411425,
        z: -2.9352731797066896,
        elevation: 0.8423963785171527,
      },
    ],
  },
  {
    name: "BlockD_102",
    category: "2BHK",
    sft: 1388,
    facing: "West",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.276951879810858,
        z: -3.0457863497191418,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.4285877903305035,
        z: -3.052565232576704,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 5.431105102251833,
        z: -3.2220100158683547,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.279491060140255,
        z: -3.2151163045228666,
        elevation: 0.8500000238418597,
      },
    ],
  },
  {
    name: "BlockD_101",
    category: "3BHK",
    sft: 1661,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.2792096540024875,
        z: -3.2420793404696395,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 5.437941925095201,
        z: -3.2456532883799287,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.4784867374087725,
        z: -3.4524216635014833,
        elevation: 0.1739999987185019,
      },
      {
        levelIndex: 0,
        x: 5.278453822222904,
        z: -3.44795229587671,
        elevation: 0.7900000214576721,
      },
    ],
  },
  {
    name: "BlockE_101",
    category: "3BHK",
    sft: 1949,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.407890819926812,
        z: -2.375574782687063,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 4.568736486534461,
        z: -2.373682461401639,
        elevation: 0.8423963785171518,
      },
      {
        levelIndex: 0,
        x: 4.572021020012536,
        z: -2.552648122201135,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.406277381051952,
        z: -2.5510943823006067,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockE_102",
    category: "3BHK",
    sft: 1949,
    facing: "North",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.634695346960911,
        z: -2.372174405407562,
        elevation: 0.8423963785171518,
      },
      {
        levelIndex: 0,
        x: 4.792076351776718,
        z: -2.3753592682070064,
        elevation: 0.84239637851715,
      },
      {
        levelIndex: 0,
        x: 4.795121925734297,
        z: -2.554314302912379,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 4.637909315048807,
        z: -2.5511394703412495,
        elevation: 0.8500000238418588,
      },
    ],
  },
  {
    name: "BlockE_103",
    category: "3BHK",
    sft: 1949,
    facing: "North",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.907855263753268,
        z: -2.3794261137114674,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.045833794598828,
        z: -2.378260292736264,
        elevation: 0.8423963785171527,
      },
      {
        levelIndex: 0,
        x: 5.041535130710593,
        z: -2.549108279212894,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.906595977438749,
        z: -2.5520378289646044,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockE_104",
    category: "3BHK",
    sft: 1949,
    facing: "North",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.1013688011175,
        z: -2.378583504220389,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.260763052939513,
        z: -2.377937027551955,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 5.259971387196234,
        z: -2.55592365432899,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 5.100246177108994,
        z: -2.5507138068038753,
        elevation: 0.8423963785171491,
      },
    ],
  },
  {
    name: "BlockE_105",
    category: "3BHK",
    sft: 1949,
    facing: "North",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.347364638350232,
        z: -2.380415993378486,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.500464641950259,
        z: -2.3770837561280564,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.496486563087264,
        z: -2.543906449817764,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.346190949055373,
        z: -2.5497264371314046,
        elevation: 0.8500000238418597,
      },
    ],
  },
  {
    name: "BlockE_106",
    category: "3BHK",
    sft: 2153,
    facing: "East",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.332847692893408,
        z: -2.0714189605981295,
        elevation: 0.8448647435519874,
      },
      {
        levelIndex: 0,
        x: 5.480789247987132,
        z: -2.0742146414297182,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.475405649519434,
        z: -2.262375170993159,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.335608922320096,
        z: -2.2676025039264873,
        elevation: 0.8500000238418597,
      },
    ],
  },
  {
    name: "BlockE_107",
    category: "3BHK",
    sft: 2287,
    facing: "West",
    store: "no",
    vacantStatus: "vacant",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 5.102898082437176,
        z: -2.076971123491319,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.253705963252935,
        z: -2.0790639078117557,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 5.259186260424386,
        z: -2.2659494614417377,
        elevation: 0.8423963785171509,
      },
      {
        levelIndex: 0,
        x: 5.105337931484815,
        z: -2.2620520771783093,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockE_108",
    category: "3BHK",
    sft: 1981,
    facing: "East",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.9113609402317095,
        z: -2.0980776189981727,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.043571301909156,
        z: -2.0985711894385277,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 5.045451220695125,
        z: -2.2700465089805224,
        elevation: 0.8454323314122689,
      },
      {
        levelIndex: 0,
        x: 4.907768532209799,
        z: -2.2702671370436267,
        elevation: 0.8500000238418579,
      },
    ],
  },
  {
    name: "BlockE_109",
    category: "3BHK",
    sft: 1981,
    facing: "West",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.6601894056758075,
        z: -2.100320806998858,
        elevation: 0.8600000143051147,
      },
      {
        levelIndex: 0,
        x: 4.818610800974198,
        z: -2.0993310254531394,
        elevation: 0.8600000143051147,
      },
      {
        levelIndex: 0,
        x: 4.814497494909626,
        z: -2.260817673531255,
        elevation: 0.8600000143051147,
      },
      {
        levelIndex: 0,
        x: 4.659292342000895,
        z: -2.275906315626245,
        elevation: 0.8423963785171509,
      },
    ],
  },
  {
    name: "BlockE_110",
    category: "3BHK",
    sft: 2310,
    facing: "East",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 4.424552295452696,
        z: -2.096647278415693,
        elevation: 0.8500000238418597,
      },
      {
        levelIndex: 0,
        x: 4.586060310038131,
        z: -2.1007843127987957,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.586998288854109,
        z: -2.304470166445757,
        elevation: 0.8500000238418579,
      },
      {
        levelIndex: 0,
        x: 4.417449489358429,
        z: -2.3027629982142246,
        elevation: 0.8423963785171509,
      },
    ],
  },
  {
    name: "Left_Lake",
    category: "3BHK",
    sft: 2310,
    facing: "East",
    store: "no",
    vacantStatus: "occupied",
    imageURL:
      "https://trynbuy-vto.s3.amazonaws.com/360/navigation_images/001.png",
    coordinates: [
      {
        levelIndex: 0,
        x: 1.9268935203312654,
        z: -1.5974449772128345,
        elevation: 0.013594528660181737,
      },
      {
        levelIndex: 0,
        x: 2.1822404317642157,
        z: -1.5948265866399574,
        elevation: 0.011198176071047783,
      },
      {
        levelIndex: 0,
        x: 2.5431399557535737,
        z: -4.0629044345500605,
        elevation: 0.013594528660178185,
      },
      {
        levelIndex: 0,
        x: 2.5042466741467386,
        z: -4.254175641604437,
        elevation: 0.013594528660174632,
      },
      {
        levelIndex: 0,
        x: 2.3211241839871155,
        z: -4.496815629135628,
        elevation: 0.013594528660181737,
      },
      {
        levelIndex: 0,
        x: 2.0985339412835886,
        z: -4.023396004331063,
        elevation: 0.013594528660188843,
      },
      {
        levelIndex: 0,
        x: 1.8282878974177517,
        z: -3.024308694122949,
        elevation: 0.013594528660192395,
      },
      {
        levelIndex: 0,
        x: 1.6402356059551408,
        z: -2.030320001600092,
        elevation: 0.013594528660181737,
      },
      {
        levelIndex: 0,
        x: 1.750080575906655,
        z: -1.769236273568037,
        elevation: 0.013594528660178185,
      },
    ],
  },
];

export const sensors = [
  // {
  //   id: "Ready to Occupy",
  //   position: {
  //     levelIndex: 0,
  //     x: 3.5090640898070085,
  //     z: -3.256354923487797,
  //     elevation: 0.4,
  //   },
  // },
];
